<template>
  <div class="social-share-bar">
    <div
      class="social-share-bar-item"
      v-for="social in socials"
      :key="social.alt"
    >
      <ImageLink
        :icon="social.image"
        :alt="social.alt"
        :link="social.link"
        v-if="social.active"
        width="20"
        height="20"
      />
    </div>
  </div>
</template>

<script>
import ImageLink from '~/components/ImageLink.vue';

export default {
  name: 'SocialShareBar',
  components: { ImageLink },
  props: {
    facebook: {
      type: Boolean,
      required: false,
      default: false,
    },
    twitter: {
      type: Boolean,
      required: false,
      default: false,
    },
    pinterest: {
      type: Boolean,
      required: false,
      default: false,
    },
    linkedin: {
      type: Boolean,
      required: false,
      default: false,
    },
    telegram: {
      type: Boolean,
      required: false,
      default: false,
    },
    sharedLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      socials: [
        {
          image: 'FacebookIcon',
          alt: 'Facebook',
          link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            this.$props.sharedLink
          )}`,
          active: this.$props.facebook,
          width: '10.5',
          height: '24.5',
        },
        {
          image: 'LinkedinIcon',
          alt: 'linkedin',
          link: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            this.$props.sharedLink
          )}`,
          active: this.$props.linkedin,
          width: '19',
          height: '18',
        },
        {
          image: 'TelegramIcon',
          alt: 'Telegram',
          link: `https://telegram.me/share/url?url=${encodeURIComponent(
            this.$props.sharedLink
          )}`,
          active: this.$props.telegram,
          width: '23',
          height: '19',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.social-share-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .social-share-bar-item {
    margin: 0 7.5px;
  }
}
</style>
